const smtPqFeaturesSection = {
    card: {
        bgColor: {
            default: 'white',
            _dark: 'gray.800'
        },
    },
    title: {
        color: {
            default: 'gray.900',
            _dark: 'gray.300'
        }
    }
}

export default smtPqFeaturesSection;